module.exports = __webpack_public_path__ + "static/media/screenshot(43).618264a4.jpg";